export default "__VITE_ASSET__BrUse9$0__"